/**
 * メインエントリーポイント
 *
 * このファイルは読み込み専用です。基本的に編集する必要はありません。
 *
 * - ベンダーの設定 → build.json
 * - ベンダーの初期化 → src/assets/vendors/xxx/init.js
 * - 独自プログラム → src/assets/js/app.js
 *
 * ※ CSSはGulpのSCSSタスクで個別にコンパイルされます
 */

// ベンダー初期化
import { initVendors } from "./vendors.js";

// アプリケーション
import { initApp } from "./app.js";

// DOM読み込み完了後に初期化
document.addEventListener("DOMContentLoaded", () => {
  // ベンダーライブラリの初期化
  initVendors();

  // アプリケーション固有の初期化
  initApp();
});
